import {
  SUBSCRIPTION_PLAN_ENTERPRISE,
  SUBSCRIPTION_PLAN_FREE
} from "../../../../../../../../constants/subscriptionPlans.js";
import { ANNUAL, EVERY_30_DAYS } from "../../../../../../../../constants/subscriptionInterval.js";

const Price = ({ plan, subscriptionInterval }) => {
  if (plan.name === SUBSCRIPTION_PLAN_FREE) {
    return <>Free</>;
  }

  if (plan.name === SUBSCRIPTION_PLAN_ENTERPRISE) {
    return <>Contact us</>;
  }

  if (plan.monthlyPrice && subscriptionInterval === EVERY_30_DAYS) {
    return <>$ {Number(plan.monthlyPrice).toFixed(2)}<span> /mo</span></>;
  }

  if (plan.yearlyPricePerMo && subscriptionInterval === ANNUAL) {
    return <>$ {Number(plan.yearlyPricePerMo).toFixed(2)}<span> /mo</span></>;
  }

  return <>Contact us</>;
};

export default Price;